export const factoryOptions = [
  { value: 'AUPLUS Factory', label: 'AUPLUS Factory' },
  { value: 'BEARWAY Factory', label: 'BEARWAY Factory' },
  { value: 'BESTCHOICE Factory', label: 'BESTCHOICE Factory' },
  { value: 'BFGOODRICH Factory', label: 'BFGOODRICH Factory' },
  { value: 'BRIDGESTONE Factory', label: 'BRIDGESTONE Factory' },
  { value: 'CHARMHOO Factory', label: 'CHARMHOO Factory' },
  { value: 'COMFORSER Factory', label: 'COMFORSER Factory' },
  { value: 'CONTINENTAL Factory', label: 'CONTINENTAL Factory' },
  { value: 'DELINTE Factory', label: 'DELINTE Factory' },
  { value: 'DOUBLE COIN Factory', label: 'DOUBLE COIN Factory' },
  { value: 'DOUBLE HAPPINESS Factory', label: 'DOUBLE HAPPINESS Factory' },
  { value: 'DOUBLES HAPPINESS Factory', label: 'DOUBLES HAPPINESS Factory' },
  { value: 'DOUBLESTAR Factory', label: 'DOUBLESTAR Factory' },
  { value: 'DUNLOP Factory', label: 'DUNLOP Factory' },
  { value: 'DURATURN Factory', label: 'DURATURN Factory' },
  { value: 'DURUN Factory', label: 'DURUN Factory' },
  { value: 'ENJOY Factory', label: 'ENJOY Factory' },
  { value: 'FALKEN Factory', label: 'FALKEN Factory' },
  { value: 'FIREMAX Factory', label: 'FIREMAX Factory' },
  { value: 'FULLRUN Factory', label: 'FULLRUN Factory' },
  { value: 'GENERAL Factory', label: 'GENERAL Factory' },
  { value: 'GOFORM Factory', label: 'GOFORM Factory' },
  { value: 'GOODYEAR Factory', label: 'GOODYEAR Factory' },
  { value: 'GREMAX Factory', label: 'GREMAX Factory' },
  { value: 'GRENLANDER Factory', label: 'GRENLANDER Factory' },
  { value: 'HAIDA Factory', label: 'HAIDA Factory' },
  { value: 'HANKOOK Factory', label: 'HANKOOK Factory' },
  { value: 'HENGFENG Factory', label: 'HENGFENG Factory' },
  { value: 'HILO Factory', label: 'HILO Factory' },
  { value: 'JINYU Factory', label: 'JINYU Factory' },
  { value: 'JOYROAD Factory', label: 'JOYROAD Factory' },
  { value: 'KAPSEN Factory', label: 'KAPSEN Factory' },
  { value: 'KINGFOREST Factory', label: 'KINGFOREST Factory' },
  { value: 'KUMHO Factory', label: 'KUMHO Factory' },
  { value: 'KUSTONE Factory', label: 'KUSTONE Factory' },
  { value: 'LAKESEA Factory', label: 'LAKESEA Factory' },
  { value: 'LANDY Factory', label: 'LANDY Factory' },
  { value: 'LEAO Factory', label: 'LEAO Factory' },
  { value: 'LIONHART Factory', label: 'LIONHART Factory' },
  { value: 'LUHE Factory', label: 'LUHE Factory' },
  { value: 'MARSHAL Factory', label: 'MARSHAL Factory' },
  { value: 'MAXTREK Factory', label: 'MAXTREK Factory' },
  { value: 'MICHELIN Factory', label: 'MICHELIN Factory' },
  { value: 'NEXEN Factory', label: 'NEXEN Factory' },
  { value: 'NORDEXX Factory', label: 'NORDEXX Factory' },
  { value: 'ONYX Factory', label: 'ONYX Factory' },
  { value: 'PACE Factory', label: 'PACE Factory' },
  { value: 'PEARL RIVER Factory', label: 'PEARL RIVER Factory' },
  { value: 'PEARLY Factory', label: 'PEARLY Factory' },
  { value: 'PIRELLI Factory', label: 'PIRELLI Factory' },
  { value: 'POWERTRAC Factory', label: 'POWERTRAC Factory' },
  { value: 'PROLOAD Factory', label: 'PROLOAD Factory' },
  { value: 'RAPID Factory', label: 'RAPID Factory' },
  { value: 'ROADCLAW Factory', label: 'ROADCLAW Factory' },
  { value: 'ROCKSTONE Factory', label: 'ROCKSTONE Factory' },
  { value: 'SAFERICH Factory', label: 'SAFERICH Factory' },
  { value: 'SUNEW Factory', label: 'SUNEW Factory' },
  { value: 'SUNSET Factory', label: 'SUNSET Factory' },
  { value: 'TEMPE Factory', label: 'TEMPE Factory' },
  { value: 'TERAFLEX Factory', label: 'TERAFLEX Factory' },
  { value: 'TOURADOR Factory', label: 'TOURADOR Factory' },
  { value: 'TOYO Factory', label: 'TOYO Factory' },
  { value: 'TRIANGLE Factory', label: 'TRIANGLE Factory' },
  { value: 'Various Factory', label: 'Various Factory' },
  { value: 'VITOUR Factory', label: 'VITOUR Factory' },
  { value: 'WANDA Factory', label: 'WANDA Factory' },
  { value: 'WANLI Factory', label: 'WANLI Factory' },
  { value: 'YOKOHAMA Factory', label: 'YOKOHAMA Factory' },
  { value: 'YOUSHENG Factory', label: 'YOUSHENG Factory' },
  { value: 'YUSTA Factory', label: 'YUSTA Factory' }
]
